export const MOTION_COMPOSITE_SEPARATOR = '|';

export function buildProjectMotionValue(
  objectID: string,
  motionId: string,
  variationNumber: number,
  index: number,
) {
  return `${objectID}:${motionId}:${variationNumber}:${index}`;
}

export const buildSceneMotionValue = buildProjectMotionValue;

export function buildCompositeMotionValue(
  projectId: string,
  motionValue: string,
) {
  return `${projectId}${MOTION_COMPOSITE_SEPARATOR}${motionValue}`;
}

export const buildCompositeSceneMotionValue = buildCompositeMotionValue;

export function parseCompositeMotionValue(compositeValue: string) {
  const separatorIndex = compositeValue.indexOf(MOTION_COMPOSITE_SEPARATOR);
  if (separatorIndex === -1) {
    return null;
  }

  return {
    projectID: compositeValue.slice(0, separatorIndex),
    motionValue: compositeValue.slice(separatorIndex + 1),
  };
}

export function parseCompositeSceneMotionValue(compositeValue: string) {
  const parsed = parseCompositeMotionValue(compositeValue);
  if (!parsed) {
    return null;
  }

  return {
    sceneID: parsed.projectID,
    motionValue: parsed.motionValue,
  };
}

export function getMotionIdFromMotionValue(motionValue: string) {
  const normalizedMotionValue =
    parseCompositeMotionValue(motionValue)?.motionValue;
  const resolvedMotionValue = normalizedMotionValue ?? motionValue;
  const parts = resolvedMotionValue.split(':');
  return parts[1] || null;
}
